import { Component, Inject, Type } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonFieldComponent } from "../form/button-field/button-field.component";
import { defaultExportContainerButtons } from '../../model/form-fields.model';
import { ButtonFieldConfig } from '../../model/form.model';
import { BUTTON_NAMES, ButtonNames } from '../../model/common.model';
import { LucideDownload } from '@lucide/angular';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [MatDialogModule, ButtonFieldComponent, NgComponentOutlet],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
  readonly downloadIcon = LucideDownload;
  readonly iconToShow: Type<unknown>;
  buttonList: ButtonFieldConfig[] = defaultExportContainerButtons;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, header: string, isCloseIcon: boolean, actionBtnsVisbile: boolean, icon?: Type<unknown> }
  ) {
    this.iconToShow = data?.icon ?? this.downloadIcon;
  }

  onClose(name: ButtonNames): void {
    const result = name === BUTTON_NAMES.Yes;
    this.dialogRef.close(result);
  }
  closeBtnOnClick(){
    this.dialogRef.close();
  }
}
